'use strict';

// makeLazy turns a dynamic-import thunk into a render function: it imports the
// page module on first call, retries once on failure (network blip / mid-session
// deploy), and invokes onError(name, err) if it still fails. The thunk MUST wrap
// a string-LITERAL import() — e.g. () => import('./games.js') — so the bundler
// can statically discover and code-split the module. Kept DOM-free (error UI is
// injected) so it is unit-testable without a browser.
//
// guard, when given, is called at dispatch and returns a predicate (see
// route-guard.js). If the predicate turns false while the module downloads, the
// route has moved on: neither the page nor onError is rendered.
export function makeLazy(load, name, onError, guard) {
  return async (...args) => {
    const isCurrent = guard ? guard() : () => true;
    let mod;
    try {
      mod = await load();
    } catch {
      try {
        mod = await load();
      } catch (err) {
        if (isCurrent()) onError(name, err);
        return undefined;
      }
    }
    if (!isCurrent()) return undefined;
    return mod[name](...args);
  };
}
